import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

interface SpotifyEmbedPlayerProps {
  playlistId: string;
  onClose: () => void;
}

export default function SpotifyEmbedPlayer({
  playlistId,
  onClose,
}: SpotifyEmbedPlayerProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-semibold text-white">{t("nowPlaying")}</h2>
        <Button
          onClick={onClose}
          data-scan-item
          className="h-14 px-8 rounded-xl bg-white/10 hover:bg-white/20 text-white font-bold text-lg"
        >
          <X className="w-5 h-5 mr-2" />
          {t("close")}
        </Button>
      </div>
      <iframe
        title="Spotify Player"
        src={`https://open.spotify.com/embed/playlist/${playlistId}?utm_source=generator&theme=0`}
        width="100%"
        height="352"
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        className="rounded-xl"
        style={{ borderRadius: 12 }}
      />
    </div>
  );
}
